import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { HomePage } from '../../../home/home';
import { TpvLoaderPage } from '../../../tpv/tpv-loader/tpv-loader';

@Component({
  selector: 'page-tutorial-tpv',
  templateUrl: 'tutorial-tpv.html',
})
export class TutorialTpvPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    if (this.globals.checkLimitsByLicense('tpv', 'tpv')) {
      this.globals.side_menu_active = 'tpv';
      this.globals.side_menu_active_analytics = false;
      this.navCtrl.setRoot(TpvLoaderPage);
    } else {
      this.navCtrl.push(HomePage);
    }
    //this.navCtrl.setRoot(PopupNewAppsPage, { app: 'pos' });
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-tpv/tutorial-tpv.ts